// An event is pinned as {{event-<id>.field}}, a series as {{series-<id>.field}}
// (O-7270). The picker value is that tag prefix, so ids never collide.
const EVENT_TAG = /\{\{(event|series)(?:-(\d+))?\./g;

export const templateEvent = (template) => {
  const matches = [...String(template || "").matchAll(EVENT_TAG)];
  const pinned = matches.find((match) => match[2]);

  return { usesEvent: matches.length > 0, eventId: pinned ? `${pinned[1]}-${pinned[2]}` : null };
};

export const retargetEvent = (template, target) => {
  const tag = /^\d+$/.test(String(target)) ? `event-${target}` : target;

  return template.replace(EVENT_TAG, `{{${tag}.`);
};
